// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-node {
  background: #fff;
  border-radius: 8px;
  width: 180px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-end-node {
  background: #a1a1aa;
  border-radius: 45px;
  padding: 5px 10px 5px 10px;
}

.custom-end-node span {
  font-weight: 400;
  font-size: 16px;
  color: white;
}

.node-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid lightgray;
  /* padding-bottom: 2%; */
}

.node-icon {
  width: 20px;
  height: 20px;
}

.node-title {
  font-size: 14px;
  font-weight: 600;
  margin-left: 5px;
}

.trigger-title {
  display: flex;
  align-items: center;
  border: 1px solid orangered;
  background-color: #fdebda;
  border-radius: 5px;
  margin-left: 5px;
  padding: 0px 5px 0px 5px;
}

.node-options {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  margin-left: auto;
}

/* .node-body {
    margin-top: 8px;
    font-size: 12px;
    color: #888;
    position: relative;
  } */

/* .warning-icon {
    position: absolute;
    right: 10px;
    bottom: -3px;
    color: #ff9800;
  } */

.react-flow__handle {
  background: black;
}
.node-details-panel {
  position: absolute;
  top: 80px;
  right: 40px;
  width: 420px;
  padding: 10px 14px 10px 14px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  min-height: 420px;
  /* max-height: 420px; */
  z-index: 1300;
}

.add-node-btn {
  color: lightgray;
  background-color: white;
  border: 1px solid lightgray;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.add-node-btn:hover {
  background-color: #0056b3;
}

.node-details-panel {
  position: absolute;
  top: 80px;
  right: 40px;
  width: 420px;
  padding: 10px 14px 10px 14px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  min-height: 420px;
  z-index: 1300;
}

.node-detail-modal-opened {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  padding: 10px 14px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  min-height: 420px;
  z-index: 1300;
}

.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  width: 45px;
}

.slider:before {
  position: absolute;
  content: '';
  height: 12px;
  width: 13px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #0a8bc7;
  right: 4px;
}

input:focus + .slider {
  box-shadow: 0 0 1px #047857;
  right: 4px;
}

input:checked + .slider:before {
  transform: translateX(24px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.react-flow__attribution a {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/modules/end-user/automator/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;KAKK;;AAEL;;;;;KAKK;;AAEL;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".custom-node {\n  background: #fff;\n  border-radius: 8px;\n  width: 180px;\n  padding: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.custom-end-node {\n  background: #a1a1aa;\n  border-radius: 45px;\n  padding: 5px 10px 5px 10px;\n}\n\n.custom-end-node span {\n  font-weight: 400;\n  font-size: 16px;\n  color: white;\n}\n\n.node-header {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid lightgray;\n  /* padding-bottom: 2%; */\n}\n\n.node-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.node-title {\n  font-size: 14px;\n  font-weight: 600;\n  margin-left: 5px;\n}\n\n.trigger-title {\n  display: flex;\n  align-items: center;\n  border: 1px solid orangered;\n  background-color: #fdebda;\n  border-radius: 5px;\n  margin-left: 5px;\n  padding: 0px 5px 0px 5px;\n}\n\n.node-options {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  margin-left: auto;\n}\n\n/* .node-body {\n    margin-top: 8px;\n    font-size: 12px;\n    color: #888;\n    position: relative;\n  } */\n\n/* .warning-icon {\n    position: absolute;\n    right: 10px;\n    bottom: -3px;\n    color: #ff9800;\n  } */\n\n.react-flow__handle {\n  background: black;\n}\n.node-details-panel {\n  position: absolute;\n  top: 80px;\n  right: 40px;\n  width: 420px;\n  padding: 10px 14px 10px 14px;\n  background-color: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  min-height: 420px;\n  /* max-height: 420px; */\n  z-index: 1300;\n}\n\n.add-node-btn {\n  color: lightgray;\n  background-color: white;\n  border: 1px solid lightgray;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.add-node-btn:hover {\n  background-color: #0056b3;\n}\n\n.node-details-panel {\n  position: absolute;\n  top: 80px;\n  right: 40px;\n  width: 420px;\n  padding: 10px 14px 10px 14px;\n  background-color: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  min-height: 420px;\n  z-index: 1300;\n}\n\n.node-detail-modal-opened {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 600px;\n  padding: 10px 14px;\n  background-color: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  min-height: 420px;\n  z-index: 1300;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 20px;\n}\n\n/* Hide default HTML checkbox */\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* The slider */\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  width: 45px;\n}\n\n.slider:before {\n  position: absolute;\n  content: '';\n  height: 12px;\n  width: 13px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  background-color: #0a8bc7;\n  right: 4px;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #047857;\n  right: 4px;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(24px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n.react-flow__attribution a {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
